import {matchPath} from "react-router";

import {isEmpty} from "@pg-mono/nodash";
import {appendQueryString, getRequest, parseSearch} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";
import {rpAppPath} from "@pg-mono/rp-routes";
import {IPaginatedResponse} from "@pg-rp/common-types";

import {fromParsedObjectToQuery, offerUrlParser} from "../../offer/helpers/friendly_offer_list/offer_url_parser";
import {OFFER_LIST_CONSTRAINTS} from "../../offer/list/constants/offer_list";
import {SearchSortString} from "../../offer/list/constants/SearchSort";
import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {ILatestQuery} from "../../utils/latest_query";

const defaultErrorResponse = {
    data: {
        results: [],
        count: 0,
        next: "",
        page: 1,
        page_size: 10,
        previous: ""
    },
    region_name_declension_where: "",
    parsedQuery: undefined
};

export interface FetchRecommendedOffersResponse {
    data: IPaginatedResponse<IOfferListOffer>;
    region_name_declension_where: string;
    parsedQuery?: ILatestQuery;
}

export const fetchRecommendedOffers = async (initialUrl: string): Promise<FetchRecommendedOffersResponse> => {
    const url = new URL(initialUrl);

    const matchedPath = matchPath<{friendlySlug: string}>(url.pathname, {
        path: rpAppPath.friendlyOfferList,
        exact: false
    });

    const matchedSubFilter = matchPath<{friendlySlug: string; offerListSubFilter?: string}>(url.pathname, {
        path: rpAppPath.friendlyOfferListSubFilterGeneral,
        exact: false
    });

    if (!matchedPath) {
        return defaultErrorResponse;
    }

    const parsedSlug = offerUrlParser(matchedPath.params.friendlySlug, matchedSubFilter?.params.offerListSubFilter);
    const searchWitchFixedAmp = url.search.split("&amp;").join("&");
    const parsedParams = parseSearch(searchWitchFixedAmp);

    if (parsedSlug === null || isEmpty(parsedSlug)) {
        return defaultErrorResponse;
    }
    const regionListApiLink = apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL);

    const regionUrl = parsedSlug.region ? appendQueryString(regionListApiLink, {slug: parsedSlug.region[0]}) : null;
    let region_name_declension_where = "";

    const regionId =
        parsedSlug.region && regionUrl
            ? await getRequest({}, regionUrl)
                  .then((data) => {
                      if (data.results[0]?.name_declension_where) {
                          region_name_declension_where = data.results[0]?.name_declension_where;
                      }
                      return data.results[0]?.id;
                  })
                  .catch(() => {
                      return defaultErrorResponse;
                  })
            : null;

    if (parsedSlug.region && !regionId) {
        return defaultErrorResponse;
    }

    if (regionId) {
        parsedSlug.region = [regionId.toString()];
    }

    const slugQuery = parsedSlug ? fromParsedObjectToQuery(parsedSlug) : {};

    const fullQuery = {...OFFER_LIST_CONSTRAINTS, ...parsedParams, ...slugQuery, page: 1, page_size: 10};

    const offerListApiLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);

    const offerListUrl = appendQueryString(offerListApiLink, fullQuery);
    return getRequest({}, offerListUrl)
        .then((response: IPaginatedResponse<IOfferListOffer>) => {
            return Promise.resolve({
                data: response,
                region_name_declension_where,
                parsedQuery: {...slugQuery, ...parsedParams, sort: slugQuery.sort ? (slugQuery.sort as SearchSortString) : undefined}
            });
        })
        .catch(() => {
            return defaultErrorResponse;
        });
};
import {matchPath} from "react-router";

import {isEmpty} from "@pg-mono/nodash";
import {appendQueryString, getRequest, parseSearch} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";
import {rpAppPath} from "@pg-mono/rp-routes";
import {IPaginatedResponse} from "@pg-rp/common-types";

import {fromParsedObjectToQuery, offerUrlParser} from "../../offer/helpers/friendly_offer_list/offer_url_parser";
import {OFFER_LIST_CONSTRAINTS} from "../../offer/list/constants/offer_list";
import {SearchSortString} from "../../offer/list/constants/SearchSort";
import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {ILatestQuery} from "../../utils/latest_query";

const defaultErrorResponse = {
    data: {
        results: [],
        count: 0,
        next: "",
        page: 1,
        page_size: 10,
        previous: ""
    },
    region_name_declension_where: "",
    parsedQuery: undefined
};

export interface FetchRecommendedOffersResponse {
    data: IPaginatedResponse<IOfferListOffer>;
    region_name_declension_where: string;
    parsedQuery?: ILatestQuery;
}

export const fetchRecommendedOffers = async (initialUrl: string): Promise<FetchRecommendedOffersResponse> => {
    const url = new URL(initialUrl);

    const matchedPath = matchPath<{friendlySlug: string}>(url.pathname, {
        path: rpAppPath.friendlyOfferList,
        exact: false
    });

    const matchedSubFilter = matchPath<{friendlySlug: string; offerListSubFilter?: string}>(url.pathname, {
        path: rpAppPath.friendlyOfferListSubFilterGeneral,
        exact: false
    });

    if (!matchedPath) {
        return defaultErrorResponse;
    }

    const parsedSlug = offerUrlParser(matchedPath.params.friendlySlug, matchedSubFilter?.params.offerListSubFilter);
    const searchWitchFixedAmp = url.search.split("&amp;").join("&");
    const parsedParams = parseSearch(searchWitchFixedAmp);

    if (parsedSlug === null || isEmpty(parsedSlug)) {
        return defaultErrorResponse;
    }
    const regionListApiLink = apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL);

    const regionUrl = parsedSlug.region ? appendQueryString(regionListApiLink, {slug: parsedSlug.region[0]}) : null;
    let region_name_declension_where = "";

    const regionId =
        parsedSlug.region && regionUrl
            ? await getRequest({}, regionUrl)
                  .then((data) => {
                      if (data.results[0]?.name_declension_where) {
                          region_name_declension_where = data.results[0]?.name_declension_where;
                      }
                      return data.results[0]?.id;
                  })
                  .catch(() => {
                      return defaultErrorResponse;
                  })
            : null;

    if (parsedSlug.region && !regionId) {
        return defaultErrorResponse;
    }

    if (regionId) {
        parsedSlug.region = [regionId.toString()];
    }

    const slugQuery = parsedSlug ? fromParsedObjectToQuery(parsedSlug) : {};

    const fullQuery = {...OFFER_LIST_CONSTRAINTS, ...parsedParams, ...slugQuery, page: 1, page_size: 10};

    const offerListApiLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);

    const offerListUrl = appendQueryString(offerListApiLink, fullQuery);
    return getRequest({}, offerListUrl)
        .then((response: IPaginatedResponse<IOfferListOffer>) => {
            return Promise.resolve({
                data: response,
                region_name_declension_where,
                parsedQuery: {...slugQuery, ...parsedParams, sort: slugQuery.sort ? (slugQuery.sort as SearchSortString) : undefined}
            });
        })
        .catch(() => {
            return defaultErrorResponse;
        });
};
